<template>
	<TwoColumns
		columns-order="flex-col lg:flex-row"
		first-column-class="items-center flex rounded"
		:second-column-class="hasContainedWithin ? 'contained-section' : ''"
	>
		<template #first>
			<CarbarImage
				image="img/sell-your-car/hero-sell-your-car.webp"
				alt="Sell your car"
				class="m-auto aspect-[4/3]"
				image-width-class="w-auto"
				sizes="xs:300px sm:400px xl:540px"
				densities="x1 x2"
				alt-text="Thinking of selling or upgrading?"
			/>
		</template>
		<template #second>
			<div class="flex w-full items-center">
				<div>
					<h2 :class="[headingClass]">{{ heading }}</h2>
					<div class="space-y-5">
						<p class="text-left">
							For a safe and hassle-free car selling experience,
							sell your car to us and receive a competitive
							trade-in price.
						</p>
						<div class="text-lg">
							<TickList
								:items="items"
								:icon-color="tickColor"
								class="m-0 text-lg"
							/>
						</div>
					</div>
					<DoubleCta
						v-if="!isListingOnly"
						class="mt-8"
						:is-stacked="false"
					>
						<template #primary>
							<SellMyCarModal
								button-text="Get an instant valuation"
							/>
						</template>
						<template #secondary>
							<CarbarLink
								font-size="text-base"
								href="/sell-my-car"
							>
								<CarbarButton
									:is-outline="true"
									:is-full-width="true"
								>
									Why sell your car to carbar?
								</CarbarButton>
							</CarbarLink>
						</template>
					</DoubleCta>
					<CarbarLink
						v-else
						font-size="text-base"
						href="/sell-my-car"
					>
						<CarbarButton class="mt-8" :is-full-width="false">
							Why sell your car to carbar?
						</CarbarButton>
					</CarbarLink>
				</div>
			</div>
			<div class="mt-8">
				<TermsAndConditions :is-full-width="false">
					<div>
						^ Valid for seven (7) days and is an invitation to
						treaty only, based on information provided by you and
						our assumptions. The instant valuation is not an offer
						to purchase by us.
						<CarbarLink
							:href="'/terms-and-conditions/instant-valuation'"
							target="_blank"
							text="Terms and conditions"
							class="text-xsm"
						/>
						apply.
					</div>
				</TermsAndConditions>
			</div>
		</template>
	</TwoColumns>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import DoubleCta from '@/components/buttons/DoubleCta.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import TickList from '@/components/lists/TickList.vue'
import SellMyCarModal from '@/components/sell-my-car/SellMyCarModal.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'

const props = defineProps({
	hasContainedWithin: {
		type: Boolean,
		default: true,
		required: false,
	},
	items: {
		type: Array,
		default: () => [
			{
				label: 'Get an instant valuation online for free^',
			},
			{
				label: 'If you’re happy with it, we’ll organise an inspection',
			},
			{
				label: 'Get paid in advance',
			},
		],
		required: false,
	},
	tickColor: {
		type: String,
		default: 'text-orange-400',
		required: false,
	},
	heading: {
		type: String,
		default: 'A simple way to sell your car',
		required: false,
	},
	headingClass: {
		type: String,
		default: '',
		required: false,
	},
})

const isListingOnly = useIsListingOnly()
</script>
